import { useRef } from "react";
import { HexColorPicker } from "react-colorful";
import { useDisclosure, useOutsideClick } from "~/hooks";
import { ColorSwatchRound } from "./ColorSwatch";

type ColorPickerV2Props = {
  value?: string;
  onChange?: (newColor: string) => void;
};

export const ColorPickerV2 = ({ value, onChange }: ColorPickerV2Props) => {
  const disclosure = useDisclosure();
  const containerRef = useRef<HTMLDivElement>(null);

  useOutsideClick({
    ref: containerRef,
    handler: () => disclosure.onClose(),
  });

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: TODO: Can we use a better element here?
    // biome-ignore lint/a11y/useKeyWithClickEvents: TODO: Improve onClick handling
    <div className="relative cursor-pointer" onClick={disclosure.onOpen} ref={containerRef}>
      <ColorSwatchRound color={value} data-testid="color-swatch" />
      <div
        className="absolute mt-1 top-10 z-50"
        style={{
          display: disclosure.isOpen ? "block" : "none",
        }}
      >
        <HexColorPicker color={value} onChange={(newColor) => onChange?.(newColor)} />
      </div>
    </div>
  );
};
